import { render, staticRenderFns } from "./ResellerLogin.vue?vue&type=template&id=49177b07&scoped=true&"
import script from "./ResellerLogin.vue?vue&type=script&lang=js&"
export * from "./ResellerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49177b07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49177b07')) {
      api.createRecord('49177b07', component.options)
    } else {
      api.reload('49177b07', component.options)
    }
    module.hot.accept("./ResellerLogin.vue?vue&type=template&id=49177b07&scoped=true&", function () {
      api.rerender('49177b07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ResellerLogin.vue"
export default component.exports